<main class="fld-col fls-1-0">
  <div class="header">
    <button
      myqq-button
      id="find-membership"
      class="find-membership raised"
      color="tertiary"
      (click)="hasMembership.emit()"
      (keydown.enter)="$event.preventDefault()"
      (keyup.enter)="hasMembership.emit()"
      [disabled]="processing"
      fill="clear"
      type="button"
      aria-label="Find membership"
    >
      Find Membership
    </button>
  </div>
  <div class="ta-c mwb-5 title">
    <h2>Tell Us About Yourself</h2>
  </div>

  <form [formGroup]="profileForm" class="form-grid" (keyup.enter)="confirm()">
    <mat-form-field id="first">
      <mat-label>First Name</mat-label>
      <input
        matInput
        placeholder="Quackals"
        required
        formControlName="firstName"
      />
    </mat-form-field>

    <mat-form-field id="second">
      <mat-label>Last Name</mat-label>
      <input
        matInput
        placeholder="McQuack"
        required
        formControlName="lastName"
      />
    </mat-form-field>

    <mat-form-field id="zip">
      <mat-label>Zip</mat-label>
      <input
        matInput
        placeholder="12345"
        required
        formControlName="zipCode"
        [mask]="zipMask"
      />
    </mat-form-field>

    <mat-checkbox
      required
      formControlName="checkbox"
      id="checkbox"
      role="checkbox"
      aria-checked="false"
      >I confirm that I'm 18 years of age or older.
    </mat-checkbox>
  </form>

  <footer class="qq-buttons">
    <div class="ds-dsk-only">
      <button
        myqq-button
        id="cancel"
        class="raised normal"
        type="submit"
        aria-label="Cancel"
        (click)="cancel()"
        (keydown.enter)="$event.preventDefault()"
        (keyup.enter)="cancel()"
      >
        {{ processing ? "" : "Cancel" }}
        <mat-spinner diameter="24" *ngIf="processing"></mat-spinner>
      </button>
    </div>

    <button
      myqq-button
      id="save"
      color="primary"
      class="process raised"
      type="submit"
      [disabled]="!profileForm.valid || processing"
      (click)="confirm()"
      (keydown.enter)="$event.preventDefault()"
      (keyup.enter)="confirm()"
      aria-label="Save"
    >
      {{ processing ? "" : "Save" }}
      <mat-spinner diameter="24" *ngIf="processing"></mat-spinner>
    </button>
  </footer>
</main>
